const PainelCart = (props) => {

    let { ling, specs, valid, onCritChange2, sh2, onSpecChange2, onSpecBlur2 } = {...props};

    function validPainel (lim) {
        let x = valid (lim, specs.lims, specs.comp, specs.crit, specs.od, ling);
        let s = {...specs};
        s.lims[lim] = x;
        props.setSpecs(s);
        console.log(specs);
    }

    function serv (specs, serv) {
        specs.res = null;
        if (specs.crit !== "Ranking") {
            specs.crit = "Intervalo";
            if (serv === 'pomp') {
                specs.lims = props.varGlob.refLim['pomp'][0];
                specs.crit = "Intervalo T";
                console.log(specs);
            } else {
                specs.lims = props.varGlob.refLim[serv];
            }
        }
        props.setSpecs(specs);
        props.setComp(serv);
    }
    
    let promptSem = "1 (Dom) a 7 (Sáb)   vazio: todos";
    if (ling === 'uk') promptSem = "1 (Sun) to 7 (Sat)   empty: all";
    let prompt = "Disponível Set2020-Fev2021";
    if (ling === 'uk') prompt = "Sep2020-Feb2021 available";

    
    return ( 
        <div className="painelcart">
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: 'top'}}>Usando como critério:  </td>
                        <td className="bgrd" style={{verticalAlign: 'top', paddingBottom: '10px'}}>
                            <input type="radio" id="rank" name="rankint" value="Ranking" 
                                onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'cart'))} defaultChecked={props.specs.crit === 'Ranking'}></input>
                            <span style={{verticalAlign: 'top'}}>Ranking</span>
                            <input type="radio" id="interv" name="rankint" value="Intervalo"
                                onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'cart'))} defaultChecked={props.specs.crit === 'Intervalo'}></input>
                            <span style={{verticalAlign: 'top'}}> Intervalo </span>
                        </td>
                    </tr>
                </tbody>
            </table> 
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{paddingBottom: '10px'}}> Limites: </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l1" value={props.specs.lims[0]} maxLength="6" size="3" onBlur={() => validPainel(0)} onChange={(e)=> props.setSpecs(sh2(0, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l2" value={props.specs.lims[1]} maxLength="6" size="2" onBlur={() => validPainel(1)} onChange={(e)=> props.setSpecs(sh2(1, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l3" value={props.specs.lims[2]} maxLength="6" size="2" onBlur={() => validPainel(2)} onChange={(e)=> props.setSpecs(sh2(2, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l4" value={props.specs.lims[3]} maxLength="6" size="2" onBlur={() => validPainel(3)} onChange={(e)=> props.setSpecs(sh2(3, e.target.value, {...props.specs}))}></input>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="serv">
                <tbody>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: 'top', textAlign: 'left'}}>DSem:  </td>
                        <td className="bgrd"><input type="text" id="Tipo" value={props.specs.tipo} placeholder={promptSem} onChange={(e) => props.setSpecs(onSpecChange2(e, 'tipo', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'tipo', {...props.specs}))}></input></td>
                        <td className="bgrd" style={{verticalAlign: 'top', width: '90px'}}>
                            <button style={{padding: '1px 23px'}}
                            type="button" title="Colorir estações em função do número de etapas"
                            onClick={() => serv (specs, "ode") }>
                            OD Et </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left'}}>Anos:  </td>
                        <td className="bgrd">
                            <input type="text" id="Anos" value={props.specs.anos} placeholder={prompt} onChange={(e) => props.setSpecs(onSpecChange2(e, 'anos', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'anos', {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{width: "75px"}}>
                            <button style={{padding: '1px 23px'}}
                            type="button" title="Colorir estações em função do número de viagens"
                            onClick={() => serv (specs, "odv") }>
                            OD Vi </button></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left'}}>Meses:  </td>
                        <td className="bgrd">
                            <input type="text" id="Meses" value={props.specs.meses} placeholder={prompt} onChange={(e) => props.setSpecs(onSpecChange2(e, 'meses', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecChange2(e, 'meses', {...props.specs}))}></input>
                        </td>
                        <td className="bgrd">
                            <button style={{padding: "1px 25px"}}
                            type="button" title="Colorir troços em função do número de validações"
                            onClick={() => serv (specs, "val") }>
                            Valid </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: "left"}}></td>
                        <td className="bgrd" style={{textAlign: "left"}}></td>
                        <td className="bgrd">
                            <button style={{padding: "1px 31px" }}
                            type="button" title="Colorir estações em função dda procura e da oferta"
                            onClick={() => serv (specs, "pomp") }>
                            PO </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left',paddingBottom: "10px"}}>DMês:  </td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <input type="text" id="DMes" onChange={(e) => props.setSpecs(onSpecChange2(e, 'dmes', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'dmes', {...props.specs}))}></input></td>
                        <td className="bgrd" style={{paddingBottom: "10px"}}>
                            <button style={{padding: "1px 26px"}} 
                            type="button" title="Colorir troços em função da oferta (DETALHES)"
                            onClick={() => serv (specs, "tms") }>
                            TMS </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default PainelCart;